module.exports = __webpack_public_path__ + "img/2（带字）.90257e96.jpg";